export interface TaskError {
  action: TaskErrorAction;
  remedy: TaskErrorRemedy;
  code: string;
  link: string;
  show: boolean;
}

export enum TaskErrorAction {
  TASK_LOAD,
  TASK_DELETE,
  TASK_CREATE,
  TASK_EDIT,
  TASK_SAVE,
  TASK_LOAD_SPECIFIC,
  TASK_TOGGLE,
}

export enum TaskErrorRemedy {
  REFRESH,
  AGAIN,
}
